import React from 'react';
import { Link } from 'react-router-dom';
import './Info.css'; // Import the CSS file
// Import images - update paths if they are different or in a subfolder
import danSmithImage from '../../assets/images/3868857a08aa8be98cbdbe5f826368bcd35c1c92.webp';
import brynKenneyImage from '../../assets/images/86394f1ea8bad5bcd68346efd4a2e57958598aff.webp';
// bryn.png will be used later

// Placeholder images for Feature Cards - UPDATE THESE PATHS
import featureCard1Image from '../../assets/images/wsop-belt.webp';
import featureCard2Image from '../../assets/images/masters.webp';
import featureCard3Image from '../../assets/images/strategy.webp';
import featureCard4Image from '../../assets/images/team.webp';

const Info = () => (
  <section className="homev2-info">
    <div className="homev2-info__main-content">
      {/* Left Column for stacked content */}
      <div className="homev2-info__left-column">
        {/* Text Content Block - Will be detailed next */}
        <div className="homev2-info__text-content-wrapper">
          {/* Inner group for heading and paragraphs */}
          <div className="homev2-info__inner-text-group">
            <h2 className="homev2-info__heading">Where Poker Meets Fantasy!</h2>
            <p className="homev2-info__paragraph">
              Welcome to One-Time Fantasy, where the thrill of fantasy sports meets the
              excitement of real-life poker competitions.
            </p>
            <p className="homev2-info__paragraph">
              Our platform is a celebration of strategy and fandom in the world of poker. Here,
              you're not just a fan; you're a team owner, crafting your dream lineup from the final
              tables of poker tournaments.
            </p>
            <p className="homev2-info__paragraph">
              One-Time Fantasy is where you play the game beyond the game, immersing
              yourself in the world of poker with a competitive twist.
            </p>
            <p className="homev2-info__paragraph">
              Join us and turn your expertise and passion for poker into victory!
            </p>
          </div>
          {/* Button is a sibling to the inner-text-group, but child of text-content-wrapper */}
          <Link to="/contests" className="homev2-info__cta-button">
            View Live Contests
          </Link>
        </div>

        {/* New container for the bottom pair */}
        <div className="homev2-info__bottom-content-pair">
          {/* Bryn Kenney Block */}
          <div 
            className="homev2-info__secondary-row-item homev2-info__bryn-block"
            style={{ backgroundImage: `url(${brynKenneyImage})` }}
          >
            {/* Content removed as it's a background image */}
          </div>
          {/* Sign Up Block */}
          <div className="homev2-info__secondary-row-item homev2-info__signup-block">
            <h3 className="homev2-info__sub-heading">Sign Up & Win Now!</h3>
            <p className="homev2-info__paragraph">
              Join One-Time Fantasy now and immerse yourself in the ultimate poker drafting experience, where real-world poker competitions come alive. Click "Sign Up Now!" and start your journey to the top today!
            </p>
            <Link to="/signup" className="homev2-info__cta-button">
              Sign Up Now!
            </Link>
          </div>
        </div>
      </div>

      {/* Right Column: Image Block (Dan Smith) */}
      <div className="homev2-info__image-block">
        <img src={danSmithImage} alt="Dan Smith" loading="lazy" style={{ width: '100%', height: '100%', display: 'block', objectFit: 'cover' }} />
      </div>
    </div>

    {/* Feature list (four cards) - This is a sibling of main-content, direct child of homev2-info */}
    <div className="homev2-info__feature-list">
      {/* Row container for the feature cards */}
      <div className="homev2-info__feature-card-row">
        {/* Card 1 */}
        <div className="homev2-info__feature-card">
          <div 
            className="homev2-info__feature-card-image" 
            style={{ backgroundImage: `url(${featureCard1Image})` }}
          ></div>
          <div className="homev2-info__feature-card-content">
            <h4 className="homev2-info__feature-card-title">Poker Tournaments</h4>
            <p className="homev2-info__feature-card-description">
              Dive into the exciting world of poker tournaments, featuring high stakes and intense competition.
            </p>
          </div>
        </div>
        {/* Card 2 */}
        <div className="homev2-info__feature-card">
          <div 
            className="homev2-info__feature-card-image" 
            style={{ backgroundImage: `url(${featureCard2Image})` }}
          ></div>
          <div className="homev2-info__feature-card-content">
            <h4 className="homev2-info__feature-card-title">Live Scoring</h4>
            <p className="homev2-info__feature-card-description">
              Stay updated with real-time scoring, keeping the thrill alive till the last moment.
            </p>
          </div>
        </div>
        {/* Card 3 */}
        <div className="homev2-info__feature-card">
          <div 
            className="homev2-info__feature-card-image" 
            style={{ backgroundImage: `url(${featureCard3Image})` }}
          ></div>
          <div className="homev2-info__feature-card-content">
            <h4 className="homev2-info__feature-card-title">Strategy</h4>
            <p className="homev2-info__feature-card-description">
              Draft players based on strategy or simply your favorites, the choice is yours.
            </p>
          </div>
        </div>
        {/* Card 4 */}
        <div className="homev2-info__feature-card">
          <div 
            className="homev2-info__feature-card-image" 
            style={{ backgroundImage: `url(${featureCard4Image})` }}
          ></div>
          <div className="homev2-info__feature-card-content">
            <h4 className="homev2-info__feature-card-title">Owning a Team</h4>
            <p className="homev2-info__feature-card-description">
              Experience the pride of team ownership and lead your squad to victory.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default Info; 